import React, { useState } from "react";
import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { colors } from "utils";

const ThumbsUpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7 10V22M15 5.88L14 10H19.83C20.1405 10 20.4467 10.0723 20.7244 10.2111C21.0021 10.35 21.2437 10.5516 21.43 10.8C21.6163 11.0484 21.7422 11.3367 21.7977 11.6422C21.8533 11.9477 21.8369 12.2619 21.75 12.56L19.42 20.56C19.2988 20.9754 19.0462 21.3404 18.7 21.6C18.3538 21.8596 17.9327 22 17.5 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V12C2 11.4696 2.21071 10.9609 2.58579 10.5858C2.96086 10.2107 3.46957 10 4 10H6.76C7.13215 9.99983 7.49671 9.89581 7.81299 9.69972C8.12926 9.50362 8.38445 9.22318 8.55 8.89L12 2C12.4716 2.00584 12.9357 2.11824 13.3578 2.32862C13.7799 2.53901 14.1489 2.84214 14.4374 3.21523C14.7258 3.58831 14.9263 4.02176 15.0237 4.48318C15.1212 4.94461 15.113 5.42214 15 5.88Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ThumbsDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M17 14V2M9 18.12L10 14H4.17C3.85951 14 3.55328 13.9277 3.27559 13.7889C2.99789 13.65 2.75629 13.4484 2.57 13.2C2.38371 12.9516 2.25785 12.6633 2.20227 12.3578C2.1467 12.0523 2.16306 11.7381 2.25 11.44L4.58 3.44C4.70117 3.02456 4.95384 2.65961 5.3 2.4C5.64616 2.14035 6.06727 2 6.5 2H20C20.5304 2 21.0391 2.21071 21.4142 2.58579C21.7893 2.96086 22 3.46957 22 4V12C22 12.5304 21.7893 13.0391 21.4142 13.4142C21.0391 13.7893 20.5304 14 20 14H17.24C16.8679 14.0002 16.5033 14.1042 16.187 14.3003C15.8708 14.4964 15.6156 14.7768 15.45 15.11L12 22C11.5284 21.9942 11.0643 21.8818 10.6422 21.6714C10.2201 21.461 9.85106 21.1579 9.56262 20.7848C9.27418 20.4117 9.07368 19.9782 8.97627 19.5168C8.87885 19.0554 8.887 18.5779 9 18.12Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SendIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none">
    <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke={colors.blue500} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const FeedbackOverlay = ({ show, sectionLabel, initialRating, onSubmit, onClose }) => {
  const [selectedRating, setSelectedRating] = useState(null);
  const [comment, setComment] = useState("");
  const [view, setView] = useState("form"); // "form" | "confirmation"

  React.useEffect(() => {
    if (show && initialRating !== undefined && initialRating !== null) {
      setSelectedRating(initialRating);
    }
  }, [show, initialRating]);

  const handleClose = () => {
    setSelectedRating(null);
    setComment("");
    setView("form");
    onClose();
  };

  const handleSubmit = () => {
    if (selectedRating === null) return;
    onSubmit(selectedRating, comment || null);
    setView("confirmation");
  };

  return (
    <StyledModal show={show} onHide={handleClose} centered>
      {view === "form" ? (
        <OverlayContent>
          <Header>
            <HeaderTitle>Give Feedback: <strong>{sectionLabel}</strong></HeaderTitle>
            <CloseBtn onClick={handleClose} aria-label="Close">
              <svg aria-hidden="true" width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5 5.5L5.5 14.5M5.5 5.5L14.5 14.5" stroke="#00140B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </CloseBtn>
          </Header>
          <Body>
            <QuestionText>
              What do you think about <strong>{sectionLabel}</strong>? Tell us what you think!
            </QuestionText>
            <RatingButtons>
              <RatingButton
                $active={selectedRating === true}
                onClick={() => setSelectedRating(true)}
              >
                <ThumbsUpIcon />
                <span>I like it!</span>
              </RatingButton>
              <RatingButton
                $active={selectedRating === false}
                onClick={() => setSelectedRating(false)}
              >
                <ThumbsDownIcon />
                <span>I don't like it</span>
              </RatingButton>
            </RatingButtons>
            <CommentSection>
              <CommentLabel>Add comments if you want to tell us more!</CommentLabel>
              <CommentInput
                placeholder=""
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </CommentSection>
            <ActionButtons>
              <CancelButton onClick={handleClose}>Cancel</CancelButton>
              <SubmitButton onClick={handleSubmit} disabled={selectedRating === null}>
                Submit
              </SubmitButton>
            </ActionButtons>
          </Body>
        </OverlayContent>
      ) : (
        <ConfirmationContent>
          <ConfirmationHeader>
            <CloseBtn onClick={handleClose} aria-label="Close">
              <svg aria-hidden="true" width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5 5.5L5.5 14.5M5.5 5.5L14.5 14.5" stroke="#00140B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </CloseBtn>
          </ConfirmationHeader>
          <ConfirmationBody>
            <SendIcon />
            <ConfirmationTitle>Thank you!</ConfirmationTitle>
            <ConfirmationText>We've received your feedback.</ConfirmationText>
          </ConfirmationBody>
        </ConfirmationContent>
      )}
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 750px;
  }

  .modal-content {
    border-radius: 16px;
    border: none;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
  }
`;

const OverlayContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const HeaderTitle = styled.h2`
  font-family: "ABC Marfa", "Inter", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.nightlyWoods500};
  margin: 0;
`;

const CloseBtn = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 100px;
  border: 2px solid #00140B;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:hover {
    background: rgba(0, 20, 11, 0.05);
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const QuestionText = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.25px;
  color: #00140B;
  margin: 0;

  strong {
    font-weight: 700;
  }
`;

const RatingButtons = styled.div`
  display: flex;
  gap: 16px;
`;

const RatingButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 22px;
  border-radius: 40px;
  background: none;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${colors.nightlyWoods500};
  border: ${(props) => props.$active ? `4px solid ${colors.blue500}` : "2px solid transparent"};
  padding: ${(props) => props.$active ? "12px 20px" : "14px 22px"};

  &:hover {
    border-color: ${colors.blue500};
    border-width: 2px;
    padding: 14px 22px;
  }
`;

const CommentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CommentLabel = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.25px;
  color: #00140B;
  margin: 0;
`;

const CommentInput = styled.textarea`
  width: 100%;
  height: 98px;
  border: 1px solid #ABB1BA;
  border-radius: 6px;
  padding: 16px;
  font-family: "Roboto", "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  color: black;
  resize: none;
  background: white;

  &:focus:not(:focus-visible) {
    outline: none;
    border-color: ${colors.blue500};
  }
`;

const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
`;

const CancelButton = styled.button`
  height: 48px;
  padding: 8px 16px;
  border-radius: 100px;
  background: white;
  border: 1px solid ${colors.blue500};
  cursor: pointer;
  font-family: "Roboto", "Inter", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: ${colors.blue500};
  line-height: normal;
  letter-spacing: 0.1px;

  &:hover {
    background: rgba(96, 93, 236, 0.05);
  }
`;

const SubmitButton = styled.button`
  height: 48px;
  padding: 8px 16px;
  border-radius: 100px;
  background: ${colors.blue500};
  border: 1px solid ${colors.blue500};
  cursor: pointer;
  font-family: "Roboto", "Inter", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #FAF7F2;
  line-height: normal;
  letter-spacing: 0.1px;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ConfirmationContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
`;

const ConfirmationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const ConfirmationBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const ConfirmationTitle = styled.h2`
  font-family: "ABC Marfa", "Inter", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: ${colors.nightlyWoods500};
  margin: 0;
`;

const ConfirmationText = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.25px;
  color: #00140B;
  margin: 0;
  align-self: flex-start;
`;
